export enum JobLoadingStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  PROGRESS = 'progress',
  FINISHED = 'finished',
}
